import { notification } from "antd";

const notificationService = {
  success: (message, description) => {
    notification.success({
      message,
      description,
    });
  },
  error: (message, description) => {
    notification.error({
      message,
      description,
    });
  },
  info: (message, description) => {
    notification.info({
      message,
      description,
    });
  },
  warning: (message, description) => {
    notification.warning({
      message,
      description,
    });
  },
  // Add other methods if needed, like `open` for custom notification types
  custom: (config) => {
    notification.open(config);
  },
};

export default notificationService;
